import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarRoute,
} from "./SidebarElements";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types"; // Import PropTypes

const Sidebar = ({ isOpen, toggle }) => {
  const { t } = useTranslation();

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="about" onClick={toggle}>
            {t("navbar.about")}
          </SidebarLink>
          <SidebarLink to="signup" onClick={toggle}>
            {t("navbar.SignUp")}
          </SidebarLink>
          <SidebarLink to="discover" onClick={toggle}>
            {t("navbar.Discover")}
          </SidebarLink>
          <SidebarLink to="services" onClick={toggle}>
            {t("navbar.Services")}
          </SidebarLink>
          <SidebarLink to="objectifs" onClick={toggle}>
            {t("navbar.objectifs")}
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to="/signin">{t("navbar.SignIn")}</SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default Sidebar;
